import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { DynamicFormArray, FIELD_TYPES, selectCheckBoxValues } from '../../model/form.model';
import { FormGroup, FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { trigger, style, animate, transition } from '@angular/animations';
import { DistributionListCheckboxChildComponent } from "../distribution-list-checkbox-child/distribution-list-checkbox-child.component";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-distribution-list-checkbox',
  standalone: true,
  imports: [MatCheckboxModule, FormsModule, DistributionListCheckboxChildComponent, MatProgressSpinnerModule, CommonModule],
  templateUrl: './distribution-list-checkbox.component.html',
  styleUrl: './distribution-list-checkbox.component.scss',
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateX(-100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class DistributionListCheckboxComponent {
  @Input() changedField!: any;
  @Input() dynamicFormArray!: DynamicFormArray;
  @Input() form!: FormGroup;
  @Output() selectionChange = new EventEmitter<selectCheckBoxValues>();
  @Output() closeCliked = new EventEmitter<any>();
  constructor(readonly cd: ChangeDetectorRef) { }
  readonly FieldType: typeof FIELD_TYPES = FIELD_TYPES;

  fieldTriggers: { [key: string]: { type: 'selectAll' | 'deselectAll'; id: number } | null } = {};
  fieldAllSelected: { [key: string]: boolean } = {};
  searchFilters: { [key: string]: string } = {};

  clearSearch(fieldName: string): void {
    this.searchFilters = { ...this.searchFilters, [fieldName]: '' };
  }

  handleSelectionChange(event: selectCheckBoxValues) {
    this.selectionChange.emit(event);
  }

  onCloseClicked() {
    this.closeCliked.emit();
  }

  onFieldAllSelectedChange(fieldName: string, checked: boolean): void {
    this.fieldAllSelected = { ...this.fieldAllSelected, [fieldName]: checked };
    this.fieldTriggers = { ...this.fieldTriggers, [fieldName]: { type: checked ? 'selectAll' : 'deselectAll', id: Date.now() } };
    this.cd.detectChanges();
  }

  onChildAllSelectedChange(fieldName: string, value: boolean): void {
    this.fieldAllSelected = { ...this.fieldAllSelected, [fieldName]: value };
    this.cd.detectChanges();
  }
}
